import { useTheme } from "@bvhi/ui-theme";
import { BounceLoader } from "react-spinners";

interface Props {
  position?: "relative" | "fixed";
}

export const BVHIBounceLoader = ({ position = "fixed" }: Props) => {
  const theme = useTheme();
  return (
    <BounceLoader
      color={theme.palette.primary.main}
      cssOverride={{ position, top: "50%", left: "50%", transform: "translate(-50%, -50%)" }}
    />
  );
};
